import { render, staticRenderFns } from "./tempCheck.vue?vue&type=template&id=36402031&scoped=true&"
import script from "./tempCheck.vue?vue&type=script&lang=js&"
export * from "./tempCheck.vue?vue&type=script&lang=js&"
import style0 from "./tempCheck.vue?vue&type=style&index=0&id=36402031&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36402031",
  null
  
)

export default component.exports